import React from 'react'
import { Create } from 'react-admin'
import { connect } from 'react-redux'

import InputList from '../inputs/InputList'
import CustomTitle from '../Title/Title'
import extendGlobalEntity from 'src/parser/entities/extendGlobalEntity'
import { transform } from '../utils/transform'

export const CustomCreate = ({ entity = {}, name, ...props }) => {
  const { id, basePath, resource } = props
  const createEntity = extendGlobalEntity(entity, 'create')

  const {
    displayedComponent: DisplayedComponent,
    properties,
    redirect = 'list',
  } = createEntity

  if (DisplayedComponent != null) {
    return (
      <DisplayedComponent
        entity={createEntity}
        name={name}
        id={id}
        basePath={basePath}
        resource={resource}
      />
    )
  }

  return (
    <Create
      title={
        <CustomTitle
          entity={createEntity}
          {...props}
        />
      }
      redirect={redirect}
      transform={transform(properties)}
      basePath={basePath}
      resource={resource}
      id={id}
      key={id}
    >
      <InputList
        entity={createEntity}
        {...props}
      />
    </Create>
  )
}

const mapStateToProps = state => {
  return {
    entities: state.definitions.entities || {},
    microservices: state.microservices,
  }
}

export default connect(mapStateToProps, null)(CustomCreate)
